<template>
  <div class="nkn-home">
    <home-header></home-header>
    <!--<home-swiper></home-swiper>-->

    <div class="containers">
      <div class="nkn-container clearfix">
        <nkn-word-map/>
      </div>

      <div class="nkn-container">
        <NMobileDownload/>
      </div>
      <!--<div class="nkn-container">
        <home-application></home-application>
      </div>-->
      <!--<div class="nkn-container">
        <platform-services></platform-services>
      </div>-->
      <div class="nkn-container">
        <pub-sub/>
        <nCDN/>
      </div>
      <!--<div class="nkn-container">
        <nCDN/>
      </div>-->

      <div class="nkn-container">
        <community-d-apps/>
      </div>

      <div class="nkn-container">
        <homenkn-why></homenkn-why>
      </div>
      <div class="nkn-container">
        <homenkn-advantage></homenkn-advantage>
      </div>
      <div class="nkn-container">
        <home-exchanges></home-exchanges>
      </div>
      <div class="nkn-container">
        <wallet-and-explorer/>
      </div>
      <div class="nkn-container">
        <Press/>
      </div>
    </div>
  </div>
</template>

<script>
  import HomeHeader from '@/components/home/nknHomeHeader'
  import HomeSwiper from '@/components/home/nknHomeSwiper'
  import HomenknWhy from '@/components/home/nknWhy'
  import HomenknAdvantage from '@/components/home/nknAdvantage'
  import HomeApplication from '@/components/home/nknApplication'
  import WalletAndExplorer from '@/components/home/nknWalletAndExplorer'
  import HomeExchanges from '@/components/about/nknExchanges'
  import PlatformServices from '@/components/home/nknPlatformServices'
  import PubSub from '@/components/home/nknPubSub'
  import nCDN from '@/components/home/nknCDN'
  import CommunityDApps from '@/components/home/nknCommunityDApps'
  import NknNodeMap from "../components/home/plugins/nknNodeMap";
  import NknWordMap from "../components/home/nknWordMap";
  import NMobileDownload from '@/components/home/nMobile'
  import Press from '@/components/home/press'

  export default {
    components: {
      NknWordMap,WalletAndExplorer,
      HomenknWhy, HomenknAdvantage, HomeApplication, HomeHeader, HomeSwiper, HomeExchanges,
      NMobileDownload, PlatformServices,PubSub,nCDN,CommunityDApps, Press
    },
    beforeRouteEnter(to, from, next) {
      next(_this => {
        _this.$NKNTasks.geoList.start()
        _this.$NKNTasks.geoSummary.start()
      })
    },
    metaInfo() {
      if (this.$i18n.locale === 'zh') {
        return {
          title: 'NKN | 一种新网络',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          attribute: '',
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'NKN是一个去中心化，基于网络传输量工作证明，可支持千万级规模节点共识的区块链系统。'
            }
          ]
        }
      } else {
        return {
          title: 'NKN | The New Kind of Network',
          // titleTemplate: '%s - by vue-meta',
          htmlAttrs: {
            lang: this.$i18n.locale
          },
          meta: [
            {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
            {
              name: 'description',
              content: 'NKN is the new kind of network connectivity protocol &amp; ecosystem powered by blockchain for an open, decentralized, and shared Internet.'
            }
          ]
        }
      }

    },
  }
</script>

<style lang="scss" scoped>
  .containers {
    width: 100%;
    padding: 0;

    .nkn-container:nth-child(even) {
      background-color: #f9faff;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/HomePortal.vue